import "./mainPage.css";
import AppContext from "../../AppContext";
import { useContext } from "react";
import React from "react";
import LoginPage from "../loginPage/loginPage";

function MainPage() {
  const { refreshUserData, setCentralState, user, activeProduct } =
    React.useContext(AppContext);

  return (
    <div className="main-body">
      <div>
        <LoginPage />
      </div>
      {/* <Link to={"/login"} style = {{marginTop: 20}}>
        <Button variant="outlined" color="secondary" >GİRİŞ</Button>
      </Link>

      <Link to={"/signup"} style = {{marginTop: 20}}>
        <Button variant="outlined" color="secondary" >KAYIT</Button>
      </Link> */}
    </div>
  );
}

export default MainPage;
